import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const OneDayExamRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const testSeriesId = params.get("test-series-id");
    const productId = params.get("product-id");
    const tabId = params.get("tab-id");

    const token = localStorage.getItem("dla_web_student_u");
    if (!token) {
        localStorage.setItem('dla_web_student_redirect_back_to_login', `/onedayexam-test-redirection?test-series-id=${testSeriesId}&product-id=${productId}&tab-id=${tabId}`);
        // Not logged in, redirect to login
        navigate('/login');
        return;
    }

    const targetUrl = `/api/v1/test_series/pts/engine?` +
      `test-series-id=${testSeriesId}` +
      `&product-id=${productId}` +
      `&is-reattempt=0` +
      `&tab-id=${tabId}` +
      `&internal_redirection=0` +
      `&language=1` +
      `&token=${token}`;

    window.location.href = targetUrl;
  }, [location, navigate]);

  return <div>Redirecting...</div>;
};

export default OneDayExamRedirect;
